import { useState } from "react";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";

export default function ReportHeader({ selectedReportPath }) {

    const [reportType, setReportType] = useState("summary");
    const [noGrouping, setNoGrouping] = useState(false);

    return (
        <div className="report-header">
            <div className="report-header-section report-header-title">
                <h2 className="report-header-heading">
                    {selectedReportPath || "Stock Reports"}
                </h2>
            </div>
            <div className="report-header-section report-header-options">
                <div className="options-row">
                    <div className="report-option">
                        <RadioButton
                            inputId="detail"
                            name="type"
                            value="detail"
                            onChange={(e) => setReportType(e.value)}
                            checked={reportType === "detail"}
                        />
                        <label htmlFor="detail">Detail</label>
                    </div>
                    <div className="report-option">
                        <Checkbox
                            inputId="noGrouping"
                            checked={noGrouping}
                            onChange={(e) => setNoGrouping(e.checked)}
                        />
                        <label htmlFor="noGrouping">No Grouping</label>
                    </div>
                </div>

                <div className="options-row">
                    <div className="report-option">
                        <RadioButton
                            inputId="summary"
                            name="type"
                            value="summary"
                            onChange={(e) => setReportType(e.value)}
                            checked={reportType === "summary"}
                        />
                        <label htmlFor="summary">Summary</label>
                    </div>
                    <div className="report-timer">
                        00:00:00
                    </div>
                </div>
            </div>

            <div className="report-header-section report-header-actions">
                <div className="report-actions">
                    <Button
                        label="Generate Report"
                        icon="pi pi-file"
                        className="app-btn app-btn-primary"
                    />
                    <Button
                        label="Clear"
                        icon="pi pi-refresh"
                        className="app-btn app-btn-secondary"
                    />
                    <Button
                        label="Exit"
                        icon="pi pi-times"
                        className="app-btn app-btn-danger"
                    />
                </div>
            </div>
        </div>
    );
}